import EzController from './ez-base-controller';

declare global {
  interface Window {
    properSpaNewPage();
  }
}

export default class AdsController extends EzController {
  // #region Types
  adsScriptLoaded: boolean;
  // #endregion

  connect() {
    window.addEventListener('turbolinks:render', this.turbolinksInitAds);
    window.addEventListener('turbolinks:before-visit', this.resetAds);
  }

  disconnect() {
    window.removeEventListener('turbolinks:render', this.turbolinksInitAds);
    window.removeEventListener('turbolinks:before-visit', this.resetAds);
  }

  turbolinksInitAds = () => {
    this.adsScriptLoaded = false;

    this.initAds();
  }

  initAds = () => {
    const properAdsScriptCheck = setInterval(() => {
      if (this.properSpaNewPageReady && !this.adsScriptLoaded) {
        window.properSpaNewPage();

        this.adsScriptLoaded = true;
      }

      if (this.properSpaNewPageReady) {
        clearInterval(properAdsScriptCheck);
      }
    }, 100);
  }

  get properSpaNewPageReady() {
    if (typeof window.properSpaNewPage === 'undefined') return false;

    return true;
  }

  resetAds = () => {
    this.disconnect();

    this.connect();
  }
}
